import React, { useState, useEffect } from 'react';
import CustomTextInput from '../InputFields/CustomTextInput';
import Dropdown from '@/components/Dropdown/Dropdown';
import CustomToggle from '../InputFields/CustomToggel';
import Button from '@/components/Button/Button';
import { v4 as uuidv4 } from 'uuid';

const FieldOptions = [
  { value: 'text_input', label: 'Text input' },
  { value: 'text_area', label: 'Text Area' },
  { value: 'file', label: 'File Upload' },
  { value: 'no_action', label: 'No Action' },
];

interface Field {
  id: string;
  label?: string;
  field_type: string;
  required?: boolean;
  [key: string]: any;
}

interface EditOptionFieldProps {
  mode: 'add' | 'edit'; // 'add' for new field, 'edit' for editing existing
  field?: Field; // present in edit mode
  onSave: (updatedField: Field) => void;
  onCancel: () => void;
}

// This component supports both add and edit modes for fields inside options
const EditOptionField: React.FC<EditOptionFieldProps> = ({ mode, field, onSave, onCancel }) => {
  const defaultField: Field = { id: uuidv4(), label: '', field_type: '', required: false };
  const [fieldState, setFieldState] = useState<Field>(
    mode === 'edit' && field ? { ...field } : defaultField
  );
  const [error, setError] = useState('');

  useEffect(() => {
    if (mode === 'edit' && field) {
      setFieldState({ ...field });
    } else if (mode === 'add') {
      setFieldState(defaultField);
    }
    setError('');
  }, [mode, field]);

  const handleLabelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldState((prev) => ({ ...prev, label: e.target.value }));
    setError('');
  };

  const handleTypeChange = (val: string) => {
    setFieldState((prev) => ({ ...prev, field_type: val }));
    setError('');
  };

  const handleRequiredChange = (val: boolean) => {
    setFieldState((prev) => ({ ...prev, required: val }));
  };

  const handleSave = () => {
    if (!fieldState.label || !fieldState.label.trim()) {
      setError('Field label is required');
      return;
    }
    if (!fieldState.field_type) {
      setError('Field type is required');
      return;
    }
    setError('');
    onSave(fieldState);
  };

  return (
    <div className="p-4 w-full max-w-lg mx-auto">
      1111111111
      <h2 className="text-lg font-semibold mb-4">{mode === 'add' ? 'Add Field' : 'Edit Field'}</h2>
      <CustomTextInput
        label="Field Label"
        name="fieldLabel"
        value={fieldState.label || ''}
        onChange={handleLabelChange}
        required
        error={error}
      />
      <div className="mt-4">
        <Dropdown
          options={FieldOptions}
          selectedValue={fieldState.field_type}
          onChange={handleTypeChange}
          error={!fieldState.field_type && !!error}
          errorMessage="Field type is required"
        />
      </div>
      <div className="mt-4">
        <CustomToggle
          label="Required"
          checked={fieldState.required ?? false}
          onChange={handleRequiredChange}
        />
      </div>
      <div className="flex gap-2 mt-4">
        <Button color="primary" onClick={handleSave}>
          {mode === 'add' ? 'Add' : 'Save'}
        </Button>
        <Button color="outlined" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default EditOptionField;
